import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { QUERY_KEYS } from '../constants';
import { useUserData } from '../queries';
import { fetchCasinoAccessToken, setCasinoAccessToken } from '../utils/api';

export const useCasinoAuth = () => {
  const { isAuthenticated } = useAuth();
  const { isSuccess, isSportsbookOnlyClient } = useUserData();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isAuthenticated || isSportsbookOnlyClient) {
      queryClient.removeQueries({ queryKey: [QUERY_KEYS.casinoGameUrl] });
      queryClient.removeQueries({ queryKey: [QUERY_KEYS.casinoTransactionsHistory] });
      setCasinoAccessToken(null);
      return;
    }

    if (!isSuccess) {
      setCasinoAccessToken(null);
      return;
    }

    (async () => {
      try {
        const token = await fetchCasinoAccessToken();
        setCasinoAccessToken(token ?? null);
      } catch (error) {
        /* eslint-disable no-console */
        console.error('Error fetching casino access token:', error);
        setCasinoAccessToken(null);
      }
    })();
  }, [isAuthenticated, isSuccess, isSportsbookOnlyClient, queryClient]);
};
